import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzni = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel10'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel8'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Find the fastest 3 horses</h1>
    
    <div class="text">
        <p>There are 25 horses among which you need to find out the fastest 3 horses. You can conduct race among at most
            5 to find out their relative speed. At no point you can find out the actual speed of the horse in a race.
            Find out how many races are required to get the top 3 horses.&nbsp;</p>
        <p><strong>The solution is 7.&nbsp;</strong></p>
        <p>First, we group the horses into groups of 5 and race each group in the race course. This gives us 5 races
            (see image below).&nbsp;</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/HorsePuzzle.png" alt="horspuzzle1"/></p><br/>

        
        
        <p>In the image, each row represents one race of 5 horses. For convenience, let us name the horses using row and
            column index. Therefore, the first race(row 1) was contested between the horses R1C1, R1C2, R1C3, R1C4 and
            R1C5. The second race (row 2) was contested between the horses R2C1, R2C2 and so on. Let us assume that the
            fifth member of each row won the race (R1C5 won the first race, R2C5 won the second race and so on), the
            fourth member of each row came second (R1C4 came second in the first race, R2C4 came second in the second
            race and so on) and the third member of each group came third (R1C3 came third in the first race, R2C3 came
            third in the second race and so on).&nbsp;</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/HorsePuzzle-1.png" alt="horsepuzzle2"/></p>
        <p>Next, we race the 5 level 1 winners (R1C5, R2C5, R3C5, R4C5 and R5C5). Let’s say R1C5 wins this race, R2C5
            comes second and R3C5 comes third.&nbsp;</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/HorsePuzzle-2.png" alt="horspicture3"/></p>
        <p>The winner of this race (R1C5) is the fastest horse of the entire group. Now, the horse which is second in
            the entire group can either be R2C5 or R1C4. The horse which is third in the entire group can either be
            R3C5, R2C4 or R1C3. Therefore, we race these 5 horses.&nbsp;</p>
        <p>&nbsp;</p>
        <p><img src="https://media.geeksforgeeks.org/wp-content/uploads/HorsePuzzle-3.png" alt="horspicture4"/></p>
        <p>Therefore, the horse R1C5 is the fastest horse. The horses which come first and second in the last race are
            the horses which are second and third in the entire group respectively. in this way, the minimum number of
            races required to determine the first, second and third horses in the entire group is 7.&nbsp;<br/>
            This
            explanation is provided by <strong>Feroz Baig</strong>&nbsp;<br/>
            &nbsp;</p>
        <h3><strong>Alternate Explanation:</strong>&nbsp;</h3>
        <p>Make group of 5 horses and run 5 races. Suppose five groups are a,b,c,d,e and next alphabet is its individual
            rank in tis group(of 5 horses).for eg. d3 means horse in group d and has rank 3rd in his group. [ 5 RACES
            DONE ]&nbsp;<br/>
            a1 b1 c1 d1 e1&nbsp;<br/>
            a2 b2 c2 d2 e2&nbsp;<br/>
            a3 b3 c3 d3 e3&nbsp;<br/>
            a4 b4 c4 d4
            e4&nbsp;<br/>
            a5 b5 c5 d5 e5&nbsp;</p>
        <p>Now make a race of (a1,b1,c1,d1,e1).[RACE 6 DONE] suppose result is a1&gt;b1&gt;c1&gt;d1&gt;e1&nbsp;<br/>
        which
            implies a1 must be FIRST.&nbsp;<br/>
            b1 and c1 MAY BE(but not must be) 2nd and 3rd.&nbsp;<br/>
            FOR II position,
            horse will be either b1 or a2&nbsp;<br/>
            (we have to find top 3 horse therefore we choose horses
            b1,b2,a2,a3,c1 do racing among them [RACE 7 DONE].&nbsp;<br/>
            The only possibilities are :&nbsp;<br/>
            c1 may be
            third&nbsp;<br/>
            b1 may be second or third&nbsp;<br/>
            b2 may be third&nbsp;<br/>
            a2 may be second or
            third&nbsp;<br/>
            a3 may be third&nbsp;<br/>
            The final result will give ANSWER. suppose result is
            a2&gt;a3&gt;b1&gt;c1&gt;b2&nbsp;<br/>
            then answer is a1,a2,a3,b1,c1.&nbsp;<br/>
            HENCE ANSWER is 7 RACES&nbsp;
        </p>
        <p>Please note that the 7 races work for the case also when all top 3 horses are same group or any top two
            horses are in same group. The group which has top 3 horses would always have winner in 6th race. In 7th
            race, we consider 2nd and 3rd horses of the group whose horse is overall winner. We also consider 2nd horse
            of the group whose horse came 2nd in 6th race.&nbsp;</p>
        
        
   
        </div>
    </article>
        </div>
      
   
        

    )
}

export default Puzni
